const dayListMapping = [
    `monday`,
    `tuesday`,
    `wednesday`,
    `thursday`,
    `friday`,
    `saturday`,
    `sunday`,
];
export { dayListMapping, };
